import React, { Component } from 'react'
import { Tab } from 'react-bootstrap'

import RelatedDocumentsBodyNavContentCollapsible from 'modules/RelatedDocuments/RelatedDocumentsBodyNavContentCollapsible'

class RelatedDocumentsBodyNavContent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true
    }
    this.tabs = []
    const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    this.tabContentHeight = windowHeight * 0.8 - 105 // Los 105 pixels son la altura de la cabecera de la modal más la altra de los tabs
  }

  componentDidMount() {
    let tabs = []
    const relatedDocumentsData = this.props.relatedDocumentsData
    if (relatedDocumentsData) {
      tabs = [...new Set(relatedDocumentsData.map(item => item.year))].sort().reverse() //Se utiliza Set para que no se añadan años repetidos
    }
    this.tabs = tabs
    if (this.state.loading) {
      this.setState({ loading: false })
    }
  }

	classifyDocumentsData = documentsData => {
	  let classifiedDocumentsDataArray = []
	  documentsData.forEach(item => {
	    let titleAlreadyExists = false
	    let titleIndex = -1

	    for (let i = 0; i < classifiedDocumentsDataArray.length; i++) {
	      if (classifiedDocumentsDataArray[i].title === item.title) {
	        titleAlreadyExists = true
	        titleIndex = i
	        break
	      }
	    }

	    if (!titleAlreadyExists) {
	      classifiedDocumentsDataArray.push({ title: item.title, data: [] })
	      titleIndex = classifiedDocumentsDataArray.length - 1
	    }
	    classifiedDocumentsDataArray[titleIndex].data.push({ description: item.description, url: item.url })
	  })

	  return classifiedDocumentsDataArray
	}

	renderTabContent = tab => {
	  let collapsibleBuffer = []
	  const documentsOfSelectedTab = this.props.relatedDocumentsData.filter(item => item.year === tab)
	  const classifiedDocumentsData = this.classifyDocumentsData(documentsOfSelectedTab)
	  classifiedDocumentsData.forEach((item, index) => {
	    if (index === 0) {
	      collapsibleBuffer.push(<RelatedDocumentsBodyNavContentCollapsible key={index} collapsed={false} documentsData={item} />)
	    } else {
	      collapsibleBuffer.push(<RelatedDocumentsBodyNavContentCollapsible key={index} collapsed={true} documentsData={item} />)
	    }
	  })

	  return collapsibleBuffer
	}

	renderIfAllOK() {
	  const tabs = this.tabs
	  let tabBuffer = []
	  let renderingComponent

	  if (!this.state.loading) {
	    for (let i = 0; i < tabs.length; i++) {
	      let tabPane = (
	        <Tab.Pane className="ork-related-documents__tab-pane" eventKey={tabs[i]} key={tabs[i]}>
	          {this.renderTabContent(tabs[i])}
	        </Tab.Pane>
	      )
	      tabBuffer.push(tabPane)
	    }
	    renderingComponent = (
	      <Tab.Content
	        animation
	        className="ork-related-documents__tab-content"
	        style={{
	          maxHeight: this.tabContentHeight + 'px'
	        }}
	      >
	        {tabBuffer}
	      </Tab.Content>
	    )
	  }

	  return renderingComponent
	}

	render() {
	  return <React.Fragment>{this.renderIfAllOK()}</React.Fragment>
	}
}

export default RelatedDocumentsBodyNavContent



// WEBPACK FOOTER //
// ./src/modules/RelatedDocuments/RelatedDocumentsBodyNavContent/RelatedDocumentsBodyNavContent.jsx